//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import { mapState } from 'vuex'
import liveDetailsl from '~/components/liveroom/liveDetailsl.vue' // 左侧
import liveDetailsr from '~/components/liveroom/liveDetailsr.vue' // 右侧
import { serverlog } from '~/utils/utils'
import liveList from '~/components/liveroom/liveList.vue' // list
import LibGenerateTestUserSig from '~/utils/lib-generate-test-usersig.min.js'
import noData from '~/components/common/noData.vue' // 404
let TRTC = {} // 直播
export default {
  components: {
    'live-detailsl': liveDetailsl, // 左侧
    'live-detailsr': liveDetailsr, // 右侧
    'live-list': liveList, // 列表
    'no-data': noData
  },
  asyncData ({ $api, app, store, res, $winstonLog, route }) {
    try {
      // console.log('route.params: ', route.params)
      // console.log('route.params.id: ', route.params.id)
      // console.log('route.params.id.split', route.params.id.split('.'))
      const liveCode = route.params && route.params.id && route.params.id.split('.')[0] // 直播id
      // console.log('liveCode: ', liveCode)
      const liveDetails = $api.liveroom.liveDetails({ // 列表初始化
        liveCode, // 直播code
        userId: store.state.contentcookie ? store.state.user.userId : '' // 用户id
      }).catch(() => {
        console.log('liveDetails直播详情页')
      })
      const liveAudience = $api.liveroom.liveAudience({ // 直播在线观众
        liveCode // 直播code
      }).catch(() => {
        console.log('liveAudience在线观众')
      })
      const liveList = $api.liveroom.liveList({ // 列表初始化
        liveLanguage: 'all', // 直播语言
        liveStatus: 3, // 直播状态
        // userId: '', // 用户id
        pageIndex: 1, // 页码
        pageSize: 8 // 页大小,
      }).catch(() => {
        console.log('liveList列表')
      })
      const livelike = $api.liveroom.livelike({ // 猜你喜欢
        userId: store.state.contentcookie ? store.state.user.userId : '', // 用户id
        pageIndex: 1, // 页码
        pageSize: 3// 条数
      }).catch(() => {
        console.log('liveList列表')
      })
      return Promise.all([liveDetails, liveAudience, liveList, livelike]).then((result) => {
        // console.log('result[0]', result[0])
        if (!result[0] || !result[0].liveDetail) {
          res.statusCode = 404
          return {
            isShownews404: true
          }
        };
        result[2] && result[2].liveListInfo && result[2].liveListInfo.items.forEach((item) => {
          item.show_time = moment(item.wiki_timestamp_start).format('MM/DD HH:mm')
          item.year = moment(item.wiki_timestamp_start).format('YYYY')
          item.day = moment(item.wiki_timestamp_start).format('MM/DD')
          item.hour = moment(item.wiki_timestamp_start).format('HH:mm')
        })
        result[3] && result[3].likeList && result[3].likeList.items.forEach((item) => {
          item.show_time = moment(item.wiki_timestamp_start).format('MM/DD HH:mm')
          item.year = moment(item.wiki_timestamp_start).format('YYYY')
          item.day = moment(item.wiki_timestamp_start).format('MM/DD')
          item.hour = moment(item.wiki_timestamp_start).format('HH:mm')
        })
        return {
          location: result[0] && result[0].liveDetail && result[0].liveDetail.camerapara && result[0].liveDetail.camerapara.location, // 摄像头位置
          liveDetail: result[0] && result[0].liveDetail, //  直播详情页数据
          liveConfig: result[0] && result[0].liveConfig, // 切流数据
          translateLanguageList: result[0] && result[0].translateLanguageList, // 字幕语言
          reportList: result[0] && result[0].reportList, // 举报数据
          liveChatList: result[0] && result[0].liveChatList, // 历史消息
          liveAudience: result[1] && result[1].count, // 在线观众
          liveListInfo: result[2] && result[2].liveListInfo && result[2].liveListInfo.items, // 直播列表
          cutflowState: result[0] && result[0].liveStatusInfo.isswitch, // 是否切流数据
          livelike: result[3] && result[3].likeList.items, // 猜你喜欢
          liveCode
        }
      }).catch((err) => {
        serverlog(err, route, store, $winstonLog)
        return { err }
      })
    } catch (errr) {
      console.log(errr, '直播获取失败')
    }
  },
  data () {
    return {
      location: 0, // 摄像头位置
      liveDetail: {}, // 直播详情
      liveConfig: {}, // 切流数据
      translateLanguageList: {}, // 字幕语言
      reportList: {}, // 举报数据
      liveChatList: {}, // 历史消息
      liveListInfo: [], // 回放八条列表
      liveAudience: 0, // 在线人数
      cutflowState: false, // 切流状态
      livelike: [], // 猜你喜欢
      endLive: false, // 结束直播
      num: 0, // 结束直播人数
      isShownews404: false, // 是否404
      mfullscreen: false,
      pageEnterTime: ''
    }
  },
  head () {
    return {
      title: this.$v('{0} - 外汇直播间-WikiFX').replace(/\{0\}/g, `${(this.liveDetail && this.liveDetail.title) ? this.liveDetail.title : 'wikifx'}`), /* .replace(/\{0\}/g, `${this.$store.state.getCountry.name}` */
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$v('WikiFX：{0}').replace(/\{0\}/g, `${(this.liveDetail && this.liveDetail.content) ? this.liveDetail.content : 'wikifx'}`)
        },
        {
          property: 'og:image',
          content: ((this.liveDetail && this.liveDetail.advanceimg) ? this.liveDetail.advanceimg : 'https://resources1.interface003.com/Contentgj/images/default1.png')
        }
      ],
      script: [
        // { src: '/js/qrcodejs-master/qrcode.js', type: 'text/javascript', charset: 'utf-8' },
        { src: '//imgcache.qq.com/open/qcloud/video/tcplayer/lib/hls.min.0.8.8.js', type: 'text/javascript', charset: 'utf-8' }
      ]
    }
  },
  computed: {
    ...mapState({
      userInfo: 'liveuserInfo'
    })
  },
  created () {
    this.liveDetail.show_time = moment(this.liveDetail.wiki_timestamp_start).format('YYYY-MM-DD HH:mm')
    this.liveDetail.hour = moment(this.liveDetail.wiki_timestamp_start).format('MM-DD HH:mm')
  },
  mounted () {
    this.pageEnterTime = Date.now()
    window.addEventListener('beforeunload', this.matomoDatefn)
    this.$nextTick(() => {
      console.log('域名', this.$store.state.cookieHost)
      if (this.liveDetail.livestatus == 1) document.querySelector('.mobile-wiki-foot').style.display = 'none'
      // if (this.liveDetail.livestatus == 1) document.querySelector('.page-width').style.display = 'none'
      // if (this.liveDetail.livestatus == 1) document.querySelector('.head-mask').style.display = 'none'
    })
    console.log('liveDetail直播详情', this.liveDetail)
    if (this.liveDetail.livestatus == 1) {
      this.$message({
        message: this.$v('直播初始化中'),
        type: 'warning'
      })
    } else if (this.liveDetail.livestatus == 3 && this.liveDetail.videos && !this.liveDetail.videos[0]) {
      this.endliveBroadcast(true)
    }

    this.$nextTick(() => {
      TRTC = require('trtc-js-sdk')
      // 设置日志输入级别
      TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.WARN)
      // 判断是否支持 webrtc, 不支持 webrtc 的网页采用【线路三：标准直播】播放，且不可切换线路
      if (this.liveDetail.livestatus == 1) {
        this.handleSupportWebRTC()
        this.handlePlayerInfo()
      }
    })
  },
  beforeDestroy () {
    this.matomoDatefn()
    window.removeEventListener('beforeunload', this.matomoDatefn)
  },
  methods: {
    fullscreen (i) {
      console.log('iaaa: ', i)
      this.mfullscreen = i
      if (i) document.querySelector('.wiki-head').style.display = 'none'
      if (i) document.querySelector('.head-mask').style.display = 'none'
      if (!i) document.querySelector('.wiki-head').style.display = 'block'
      if (!i) document.querySelector('.head-mask').style.display = 'block'
    },
    Cameraposition (e) {
      console.log('e: ', e)
      this.location = e
    },
    // 处理是否支持 webRTC
    async handleSupportWebRTC () {
      const supportResult = await TRTC.checkSystemRequirements()
      const { isWebRTCSupported, isH264DecodeSupported } = supportResult.detail
      if (!isWebRTCSupported || !isH264DecodeSupported) {
        this.$store.commit('SET_IS_SUPPORT_WEBRTC', false)
        this.$store.commit('UPDATE_LINE_TYPE', 'cdn') // cdn 播放
      }
    },
    async countdown () {
      const liveCode = this.$route.params.id && this.$route.params.id.split('.')[0] // 直播id
      const res = await this.$api.liveroom.liveDetailscl({
        liveCode, // 直播code
        userId: this.$store.state.contentcookie ? this.$store.state.user.userId : '' // 用户id
      })
      this.liveDetail = res.liveDetail
      if (this.liveDetail.livestatus == 1) location.reload()
    },
    // 处理页面数据
    handlePlayerInfo () {
      // console.log('liveDetail', this.liveDetail)
      // const userId = this.$store.state.contentcookie ? this.$store.state.user.userId : `${Math.floor(Math.random() * 100)}`
      const generator = new LibGenerateTestUserSig(1400638854, 'bc3c6563bea91d2d26cafdfb78e572ea7c4dabcb0ee505a8fa2b04fff434821e', 604800)
      const userSig = generator.genTestUserSig(this.userInfo.userId)
      this.$store.commit('SET_USER_SIG', userSig)
      this.$store.commit('SET_ROOM_ID', this.liveDetail.roomid)
      this.$store.commit('SET_ROOM_NAME', this.liveDetail.title ? this.liveDetail.title : 'WikiFx')
      this.$store.commit('SET_ANCHOR_USER_ID', this.liveDetail && this.liveDetail.users[0] && this.liveDetail.users[0].userId)
      // this.$store.commit(UPDATE_USER_INFO, {
      //   userId: userInfo.userId,
      //   userName: userInfo.userName,
      //   userAvatar: ''
      // })
    },
    TangentialFlow (state) { // 切流切换
      this.cutflowState = state
    },
    async endliveBroadcast (state) {
      const liveCode = this.$route.params.id && this.$route.params.id.split('.')[0] // 直播id
      const res = await this.$api.liveroom.liveEndlive({
        liveCode // 直播code
      })
      this.num = res.num
      this.endLive = state
    },
    // 埋点方法
    matomoDatefn () {
      this.matomofn('Live_Time', {
        type: this.liveDetail?.livestatus == 1 ? '直播' : (this.liveDetail?.livestatus == 2 ? '预告' : '回放'),
        af_Enter: this.pageEnterTime,
        af_Exit: Date.now(),
        title: this.liveDetail?.title || '',
        code: this.liveCode || ''
      })
    }
  }
}
